import { forwardRef } from 'react';
export function DnDHOCLegacy(component) {
  const SharedDragDropContext =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('customer-data-ui-utilities/dnd/SharedDragDropContext').default;
  return SharedDragDropContext()( /*#__PURE__*/forwardRef(component));
}